// composables/fetch.ts
import type { NitroFetchRequest } from 'nitropack'
import type { RequestResponse } from '@/types/publicType'
import { useLanguageStore } from '@/stores/language'
import qs from 'qs'
interface Params {
  url: NitroFetchRequest
  data?: Record<string, any>
  params?: Record<string, any>
  method?: 'GET' | 'POST'
  loading?: boolean
  isFormData?: boolean
  isCloseTost?: boolean //是否关闭提示
}

let needLoadingRequestCount = 0

export async function getFetchData<T = RequestResponse<any>>({
  url,
  data,
  params,
  method = 'GET',
  loading = false,
  isFormData = false,
  isCloseTost = false
}: Params): Promise<T> {
  return new Promise((resolve, reject) => {
    const runtimeConfig = useRuntimeConfig()

    $fetch(url, {
      method,
      baseURL:
        runtimeConfig.public.appMode === 'development'
          ? '/api'
          : runtimeConfig.public.apiUrl,
      headers: {
        Platform: common.checkVersion().app ? '' : 'web'
      },
      // onRequest相当于请求拦截
      onRequest({ options }) {
        // 需要转菊花时，loading传true
        if (loading) {
          if (needLoadingRequestCount === 0) {
            showLoadingToast({
              message: '',
              forbidClick: true,
              duration: 0
            })
          }
          needLoadingRequestCount++
        }

        // 设置请求参数
        if (isFormData) {
          options.body = data
        } else {
          const uid = localStorage.getItem('loginInfo')
            ? JSON.parse(localStorage.getItem('loginInfo') as string).uid
            : 0
          const languageStore = useLanguageStore() // 此字段不限制于接口，所以可以直接使用
          const publicData = {
            uid,
            ticket: localStorage.getItem('ticket'),
            language: languageStore.languageInfo.value,
            app: 'xchat',
            os: 'web',
            appVersion: runtimeConfig.public.version
          }
          if (method === 'POST') {
            // 设置请求头
            options.headers = {
              ...options.headers,
              'Content-Type': 'application/x-www-form-urlencoded'
            }
            options.body = qs.stringify({
              ...publicData,
              ...data
            })
          } else {
            options.query = {
              ...publicData,
              ...params
            }
          }
          console.log(`request => ${method}: ${url}\n`, {
            ...publicData,
            ...params,
            ...data
          })
        }
      },
      // onResponse相当于响应拦截
      onResponse({ response }) {
        // console.log('response', response)
        if (loading) {
          needLoadingRequestCount--
          if (needLoadingRequestCount <= 0) {
            closeToast()
          }
        }
        console.log(`response => ${method}: ${url}\n`, response._data)
        // 未设置状态码则默认成功状态
        const code = response._data.code || 200
        // 获取错误信息
        const message = response._data.message
        if (code === 401) {
          const publicStore = usePublicStore()
          publicStore.resetLogin({ msg: '接口API-401', type: 'api' })
        }
        if (code !== 200 && !isCloseTost) {
          showToast({
            message,
            'z-index': 9999
          })
        }
      },
      onRequestError({ error }) {
        // 处理请求错误
        console.warn('[onRequestError]', error)
      },
      onResponseError({ response }) {
        // 处理响应错误
        console.warn('[onResponseError]', response)
      }
    })
      .then((res) => {
        // console.log('请求响应', res)
        resolve(res as T)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
